import { render, staticRenderFns } from "./SearchPriorityCampaign.vue?vue&type=template&id=fbff2bd6"
import script from "./SearchPriorityCampaign.vue?vue&type=script&lang=js"
export * from "./SearchPriorityCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports